import { getAPIDomain } from "./config";

export const loginUser = async (email, password) => {
  try {
    const res = await fetch(`${getAPIDomain()}/api/users/login`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email, password }),
    });
    const data = await res.json();
    if (res.ok && data.token) {
      localStorage.setItem("token", data.token);
    }
    return data;
  } catch (err) {
    console.error("Log Failed In!", err);
    throw err;
  }
};

export const logoutUser = async (email) => {
  try {
    const res = await fetch(`${getAPIDomain()}/api/users/logout`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email }),
    });
    const data = await res.json();
    return data;
  } catch (err) {
    console.error("Logout Failed!", err);
    throw err;
  }
};

const logoutAndRedirect = async () => {
  try {
    const email = localStorage.getItem("email");
    const loginTime = localStorage.getItem("loginTimestamp");
    if (email) {
      const response = await logoutUser(email);
      if (response.logoutTimestamp && loginTime) {
        const sessionDuration = new Date(response.logoutTimestamp) - new Date(loginTime);
        const minutes = Math.floor(sessionDuration / (1000 * 60));
        const seconds = Math.floor((sessionDuration % (1000 * 60)) / 1000);
      }
    }
  } catch (err) {
    console.error("Error during logout:", err);
  } finally {
    localStorage.removeItem("token");
    localStorage.removeItem("email");
    localStorage.removeItem("user");
    localStorage.removeItem("loginTimestamp");
    localStorage.clear();
    window.location.href = "/";
  }
};


export async function getGeoWoreda(limit = 100, onBatchFetched) {
  const totalWoredas = 1000;
  const totalBatches = Math.ceil(totalWoredas / limit);

  for (let batch = 0; batch < totalBatches; batch++) {
    const offset = batch * limit;

    const res = await fetch(
      `${getAPIDomain()}/api/geo/woreda?limit=${limit}&offset=${offset}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    const data = await res.json();

    const features = data.map((d) => ({
      type: "Feature",
      geometry: d.geometry,
      properties: {
        WOREDANAME: d.woreda,
        ZONENAME: d.zone,
        REGIONNAME: d.regionalState,
        factors: {
          temperature_C: d?.parameters?.weather?.temperature_C ?? null,
          humidity: d?.parameters?.weather?.humidity ?? null,
          rainfall: d?.parameters?.rainfall ?? null,
          water_bodies: d?.parameters?.water_bodies ?? null,
          endemicity: d?.endemicity ?? null
        },
      },
    }));
    // Notify UI about this batch
    onBatchFetched(features, batch === totalBatches - 1);
  }
}
export async function getGeoRegionalState() {
  try {
    const token = localStorage.getItem("token");
    const res = await fetch(
      `${getAPIDomain()}/api/geo/regional-state`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (!res.ok) {
      if (res.status === 401 || res.status === 403) {
        logoutAndRedirect();
      } else {
        throw new Error(`Failed to fetch geo-regional-state: ${res.status}`);
      }
    }
    const data = await res.json();
    return data;
  } catch (err) {
    console.error("Error fetching geo-woreda:", err);
    throw err;
  }
}

export async function predictSingleAPI(inputs) {
  try {
    const token = localStorage.getItem("token");
    const res = await fetch(`${getAPIDomain()}/api/predict/predict_single`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(inputs),
    });

    const data = await res.json();
    if (!res.ok) {
      if (res.status === 401 || res.status === 403) {
        logoutAndRedirect();
      } else {
        throw new Error(`Prediction Failed: ${res.status}`);
      }
    }
    return data;
  } catch (err) {
    console.error("Single prediction failed:", err);
    throw err;
  }
}

export async function predictBatchAPI(file) {
  try {
    const token = localStorage.getItem("token");
    const formData = new FormData();
    formData.append("file", file);

    const res = await fetch(`${getAPIDomain()}/api/predict/predict-batch`, {
      method: "POST",
      headers: { Authorization: `Bearer ${token}` },
      body: formData,
    });

    const data = await res.json();
    if (!res.ok) {
      if (res.status === 401 || res.status === 403) {
        logoutAndRedirect();
      } else {
        throw new Error(`Prediction Failed: ${res.status}`);
      }
    }
    return data.results;
  } catch (err) {
    console.error("Batch prediction failed:", err);
    throw err;
  }
}
export const fetchParameters = async (key) => {
  try {
    const token = localStorage.getItem("token");
    const res = await fetch(`${getAPIDomain()}/api/locations/${key}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (!res.ok) {
      const data = await res.json();
      if (res.status === 401 || res.status === 403) {
        logoutAndRedirect();
      } else if (res.status === 400 && data.error) {
        throw new Error(data.error || "Unknown error occurred");
      } else {
        throw new Error(data.message || "Unknown error occurred");
      }
    }
    const data = await res.json();
    return data;
  } catch (err) {
    throw err;
  }
}
export async function fetchRegionalStateParameters() {
  try {
    const token = localStorage.getItem("token");
    const res = await fetch(`${getAPIDomain()}/api/locations/regional-state`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (!res.ok) {
      const data = await res.json();
      if (res.status === 401 || res.status === 403) {
        logoutAndRedirect();
      } else if (res.status === 400 && data.error) {
        throw new Error(data.error || "Unknown error occurred");
      } else {
        throw new Error(data.message || "Unknown error occurred");
      }
    }
    const data = await res.json();
    return data;
  } catch (err) {
    throw err;
  }
}

export const fetchUsers = async () => {
  try {
    const token = localStorage.getItem("token");
    const res = await fetch(`${getAPIDomain()}/api/users`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (!res.ok) {
      const data = await res.json();
      if (res.status === 401 || res.status === 403) {
        logoutAndRedirect();
      } else if (res.status === 400 && data.error) {
        throw new Error(data.error || "Unknown error occurred");
      } else {
        throw new Error(data.message || "Unknown error occurred");
      }
    }
    const data = await res.json();
    return data;
  } catch (err) {
    throw err;
  }
};
export const fetchUserById = async (userId) => {
  try {
    const token = localStorage.getItem("token");
    const res = await fetch(`${getAPIDomain()}/api/users/${userId}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (!res.ok) {
      const data = await res.json();
      if (res.status === 401 || res.status === 403) {
        logoutAndRedirect();
      } else if (res.status === 400 && data.error) {
        throw new Error(data.error || "Unknown error occurred");
      } else {
        throw new Error(data.message || "Unknown error occurred");
      }
    }
    const data = await res.json();
    return data.user;
  } catch (err) {
    throw err;
  }
};
export const createUser = async (user) => {
  const token = localStorage.getItem("token");
  try {
    const res = await fetch(`${getAPIDomain()}/api/users/register`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(user),
    });

    const data = await res.json();

    if (!res.ok) {
      if (res.status === 401 || res.status === 403) {
        logoutAndRedirect();
      } else if (res.status === 400 && data.error) {
        throw new Error(data.error);
      } else {
        throw new Error(data.error || "Unknown error while creating user");
      }
    }
    const userData = await fetchUserById(data.userId);
    return userData;
  } catch (err) {
    throw err;
  }
};
export const createAdmin = async (user, authenticateRole) => {
  if (authenticateRole === "admin" && user.role === "admin") {
    throw new Error("Admins are not allowed to update other admins");
  }
  const token = localStorage.getItem("token");
  try {
    const res = await fetch(`${getAPIDomain()}/api/users/register`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(user),
    });

    const data = await res.json();

    if (!res.ok) {
      if (res.status === 401 || res.status === 403) {
        logoutAndRedirect();
      } else if (res.status === 400 && data.error) {
        throw new Error(data.error);
      } else {
        throw new Error(data.error || "Unknown error while creating admin");
      }
    }
    const userData = await fetchUserById(data.userId);
    return userData;
  } catch (err) {
    throw err;
  }
};
export const updateUserApi = async (id, updated, authenticateRole) => {
  if (authenticateRole === "admin" && updated.role === "admin") {
    throw new Error("Admins are not allowed to update other admins");
  }
  const token = localStorage.getItem("token");
  try {
    const body = {
      ...updated,
      authenticateRole,
    };
    const res = await fetch(`${getAPIDomain()}/api/users/${id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(body),
    });

    const data = await res.json();
    if (!res.ok) {
      if (res.status === 401 || res.status === 403) {
        logoutAndRedirect();
      } else if (res.status === 400 && data.error) {
        throw new Error(data.error);
      } else {
        throw new Error(data.error || "Unknown error while updating user");
      }
    }
    return data.user;
  } catch (err) {
    throw err;
  }
};
export const deleteUserApi = async (id, userToDelete, authenticateRole) => {
  if (authenticateRole === "admin" && userToDelete?.role === "admin") {
    throw new Error("Admins are not allowed to delete other admins");
  }

  const token = localStorage.getItem("token");
  const res = await fetch(`${getAPIDomain()}/api/users/${id}`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });

  const data = await res.json();

  if (!res.ok) {
    if (res.status === 401 || res.status === 403) {
      logoutAndRedirect();
    } else if (res.status === 400 && data.error) {
      throw new Error(data.error);
    } else {
      throw new Error(data.error || "Unknown error while deleting user");
    }
  }

  return data;
};

